import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Box, Fade, LinearProgress, Stack } from '@mui/material';
import { Camera, Trash2 } from 'lucide-react';
import { useRef } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import { BANNER_HEIGHT, BANNER_PLACEHOLDER_BY_TYPE, BannerFormType } from './bannerForm.constants';

type BannerFormProps = {
  bannerUrl: string | null;
  type: BannerFormType;
  isLoading?: boolean;
  onChange: (file?: File) => void;
};

const BannerForm = ({ bannerUrl, isLoading, type, onChange }: BannerFormProps) => {
  const { translate } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (files: FileList | null) => {
    if (files?.[0]) {
      onChange(files[0]);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack direction="row" sx={{ gap: 2, zIndex: 1, position: 'absolute' }}>
          {bannerUrl && (
            <IconButton
              icon={Trash2}
              size="large"
              color="secondary"
              ariaLabel={translate(LangEnum.GLOBAL_REMOVE_PHOTO)}
              disabled={isLoading}
              onClick={() => onChange(undefined)}
            />
          )}
          <IconButton
            icon={Camera}
            size="large"
            color="secondary"
            ariaLabel={translate(LangEnum.GLOBAL_ADD_PHOTO)}
            disabled={isLoading}
            onClick={() => inputRef.current?.click()}
          />
        </Stack>

        <input
          hidden
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={(event) => {
            handleFileChange(event.target.files);
            event.target.value = '';
          }}
        />

        <Box
          component="img"
          alt=""
          src={bannerUrl || BANNER_PLACEHOLDER_BY_TYPE[type]}
          sx={{
            height: BANNER_HEIGHT,
            display: 'block',
            width: '100%',
            borderRadius: 1,
            objectFit: bannerUrl ? 'cover' : 'inherit',
          }}
        />
      </Box>
      <Fade in={isLoading}>
        <LinearProgress />
      </Fade>
    </>
  );
};

export default BannerForm;
